import { IconProps } from '@shared/interfaces/icon.interface';
import * as React from 'react';

export const BananasIcon: React.FC<IconProps> = ({ width = 28, height = 28, className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 128 128"
    xmlSpace="preserve"
    width={width}
    height={height}
    className={className}
  >
    <path
      style={{
        fill: '#ff8e00',
      }}
      d="M119.22 95.12c-1.14 2.36-5.91 2.21-8.54 1.38-6.72-2.12-10.9-7.9-10.9-7.9L65.14 73.9l-10.61-5.57s-2.06-3.5 2.06-6.17 7.01-2.87 7.01-2.87l11.94 7.6s7.71-6 15.54-6.91c7.48-.86 16.79 5.22 19.24 16.7 1.99 9.31 5.14 12.59 6.09 13.8.95 1.22 3.79 2.62 2.81 4.64z"
    />
    <path
      style={{
        fill: '#ffe4b4',
      }}
      d="M77.72 32.15C74.65 21.99 70.77 10.1 64.91 6.03c-5.19-3.6-10.24-2.95-12.64-1.38 0 0-4.33 1.77-5.47 6.24-1.88 7.34.59 16.15 2.2 25.25 1.61 9.1 2.45 15.36 3.18 22.67.07.66 12.16 22.18 12.16 22.18l9.65 5.17s7.37-15.94 7.26-18.19c-.1-2.26-1.29-28.4-3.53-35.82z"
    />
    <path
      style={{
        fill: '#ffe265',
      }}
      d="M52.55 66.94c-.13 2.43 5.73 21.8 5.73 21.8L74 86.14s11.15-6.6 11.46-18.57c.48-18.05-2.61-26.55-4.85-33.97-3.08-10.14-9.94-23.5-15.75-27.64-3.41-2.43-7.19-2.79-8.74-2.49 0 0 10.32 8.08 15.54 21.9s6.45 29.79 6.45 29.79-3.84 2.83-12.9 4.13c-7 1.01-13.04-.7-13.04-.7s.55 5.27.38 8.35z"
    />
    <path
      style={{
        fill: '#ffa726',
      }}
      d="m85.33 83.75-6.29-13.14.34-4.68s1.34-3.93-7.03 2.42c-3.88 2.94-6.22 8.36-6.22 8.36s-1.18-2.92-5.32-6.78c-3.68-3.42-8.63-5.08-8.63-5.08s-10.28-2-11.4-1.13c-7.25 5.66-12.55 12.55-12.55 12.55L22.9 96.42l-8.86 5.43s2.42 3.54 5.92 2.22c2.73-1.03 6.11-4.12 7.93-8.01 2.5-5.35 7.75-15.47 10.42-18.67 5.16-6.16 10.22-8.41 13.99-6.62 4.29 2.03.86 22.29.86 22.29l-27.58 23.21-.47 3.16s4.01 3.85 15.06 3.49 25.83-4.45 35.18-17.2c8.25-11.24 9.98-21.97 9.98-21.97z"
    />
    <path
      style={{
        fill: '#ffb803',
      }}
      d="M63.58 84.96c.24 5.55-3.22 13.96-11.22 20.97-7.99 7.01-16.43 9.33-21.67 9.73-3.8.29-4.93-1.88-4.93-1.88s7.66-7.05 13.35-12.7c5.4-5.37 11.28-16.65 12.56-21.84 1.28-5.19.12-8.68.12-8.68s2.48.69 6.13 4.35c3.54 3.55 5.53 6.97 5.66 10.05z"
    />
    <path
      style={{
        fill: '#875b54',
      }}
      d="M29.45 118.74c-.83 1.93-3.68 2.01-4.92.94-1.17-1.01-2.31-3.02-1.13-5.27.78-1.48 3.34-1.89 4.78-.74s2.02 3.32 1.27 5.07z"
    />
    <path
      style={{
        fill: '#fee4b4',
      }}
      d="M23.76 97.84c-3.28 4.55-6.57 5.24-7.93 5.39-1.19.14-2.49-1.38-2.34-2.78.15-1.4 2.45-3.37 2.73-7.67.28-4.3-.06-20.07 8.69-29.13 6.17-6.38 13.73-4.18 18.61-2.49 5.5 1.9 8.67 3.7 8.67 3.7s-4.5-.31-12.26 5.81c-4.51 3.56-7.16 8.45-9.66 14.06-1.8 4.06-4.2 9.91-6.51 13.11z"
    />
    <path
      style={{
        fill: '#feb804',
      }}
      d="M111 109.58c-.92 1.84-3.17 2.98-5.16 2.89-4.21-.18-8.05-2.35-12.3-7.83-6.01-7.76-11.24-26.38-15.16-31.34-2.65-3.35-5.95-5.01-5.95-5.01s1.82-1.54 3.64-2.49c1.82-.95 6.22-.5 6.22-.5l18.78 30.18 9.93 14.1z"
    />
    <path
      style={{
        fill: '#ffe4b4',
      }}
      d="M100.39 68.46c4.12 5.89 4.66 11.06 5.28 16.34.56 4.77 1.71 14.8 3.44 18.07 1.74 3.27 3.43 5.4 1.56 7.39s-7.37 1.28-11.32-3.02c-3.18-3.47-4.94-7.25-7.33-12.8-2.39-5.55-5.91-18.65-10.48-24.57-2.92-3.78-5.83-3.89-5.83-3.89s3.85-3.14 11.2-3.22c6.59-.07 10.05.8 13.48 5.7z"
    />
  </svg>
);

export default BananasIcon;
